import { createContext } from 'react';
import dayjs from 'dayjs';

import {
  EmployeeUtilizationReportRequest,
  EmployeeUtilizationSummaryReport,
} from '@totem/components/ticketing/employeeUtilization/models';
import { getDefaultStartDate } from '@totem/components/ticketing/employeeUtilization/utilities';

interface Context {
  loading: boolean;
  input: EmployeeUtilizationReportRequest;
  setInput: (updated: Partial<EmployeeUtilizationReportRequest>) => void;
  rawData: EmployeeUtilizationSummaryReport;
  action: string;
  actionItem: string;
  onAction: (action: string, actionItem: string) => void;
  holidays: string[];
}

export default createContext<Context>({
  loading: false,
  input: {
    startTime: getDefaultStartDate(),
    endTime: dayjs().toISOString(),
    department: [],
    employee: [],
  },
  setInput: () => {},
  rawData: null,
  action: '',
  actionItem: '',
  onAction: () => {},
  holidays: [],
});
